import { defineComponent as x, ref as p, computed as C, createBlock as r, openBlock as a, unref as e, withCtx as s, createElementVNode as d, normalizeClass as i, createVNode as u, createTextVNode as h, toDisplayString as b, normalizeStyle as y, Teleport as L, createElementBlock as V, createCommentVNode as N, Fragment as B, renderList as S } from "vue";
import { useFloating as E, offset as R, flip as z, shift as D, autoUpdate as F } from "@floating-ui/vue";
import { Listbox as O, ListboxButton as T, ListboxOptions as U, ListboxOption as W } from "@headlessui/vue";
import { ScalarIconCaretDown as _ } from "@scalar/icons";
const $ = { class: "option-label" }, q = /* @__PURE__ */ x({
  __name: "HeaderListbox",
  props: {
    options: {},
    modelValue: {},
    static: { type: Boolean },
    buttonName: {},
    buttonClass: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const m = p(null), n = p(null), g = C(
      () => n.value?.children?.[0] || n.value
    ), { floatingStyles: k } = E(g, m, {
      placement: "bottom-start",
      whileElementsMounted: F,
      middleware: [R(5), z(), D()]
    });
    return (c, f) => (a(), r(e(O), {
      as: "div",
      modelValue: t.modelValue,
      "onUpdate:modelValue": f[0] || (f[0] = (l) => c.$emit("update:modelValue", l))
    }, {
      default: s(({ open: l }) => [
        d("div", {
          ref_key: "buttonWrapper",
          ref: n,
          class: i({
            "button-wrapper": !!c.$slots.default
          })
        }, [
          u(e(T), {
            as: "button",
            class: i(["header-item-link header-group-link", t.buttonClass])
          }, {
            default: s(() => [
              h(b(t.buttonName) + " ", 1),
              u(e(_), {
                style: y({
                  transform: l ? "rotate(180deg)" : "rotate(0deg)"
                })
              }, null, 8, ["style"])
            ]),
            _: 2
          }, 1032, ["class"])
        ], 2),
        (a(), r(L, {
          disabled: t.static,
          to: "#app"
        }, [
          l ? (a(), V("div", {
            key: 0,
            ref_key: "dropdownRef",
            ref: m,
            class: "floating",
            style: y(e(k))
          }, [
            u(e(U), {
              class: "dropdown",
              static: ""
            }, {
              default: s(() => [
                (a(!0), V(B, null, S(t.options, (o) => (a(), r(e(W), {
                  key: o.id,
                  as: "template",
                  disabled: o.disabled,
                  value: o
                }, {
                  default: s(({ active: w, selected: v }) => [
                    d("li", {
                      class: i(["option", { active: w, selected: v }])
                    }, [
                      d("span", $, b(o.label), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["disabled", "value"]))), 128))
              ]),
              _: 1
            })
          ], 4)) : N("", !0)
        ], 8, ["disabled"]))
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
});
export {
  q as default
};
